export const safeEmpty = (str?: string) => {
  if (!str?.trim()) return '-';
  return str;
};
